import { render } from "./VehicleDetail.vue?vue&type=template&id=5e9f1a20&scoped=true&ts=true"
import script from "./VehicleDetail.vue?vue&type=script&lang=ts"
export * from "./VehicleDetail.vue?vue&type=script&lang=ts"

import "./VehicleDetail.vue?vue&type=style&index=0&id=5e9f1a20&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9f1a20"]])

export default __exports__